import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { SalesCycleCheckListDialog } from '../sales-cycle-checklist/sales-cycle-checklist.component';
import { EditOpportunityDialog } from '../edit-opportunity/edit-opportunity.component';
import { InitiativesDropdown } from '../initiatives-dropdown/initiatives-dropdown.component';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { OrderService } from '../../services/order.service';
import {
    CustomerInitiative,
    Employee,
    //SalesCycle,
    OpportunitySalesCycleMap,
    SearchCRMOpportunity,
    SearchTagType
} from '../../models/models';

@Component({
    selector: 'crm-opportunities',
    templateUrl: './crm-opportunities.component.html',
    standalone: false
})
export class CrmOpportunities implements OnInit {

    @ViewChild(InitiativesDropdown, { static: false }) initiativesDropdown: InitiativesDropdown | undefined;

    private repType: string = '';
    private employeeId: number = 0;
    private refreshOpps: boolean = false;

    //public salesCycles: SalesCycle[] = [];
    public test: any = {};
    public opportunities: SearchCRMOpportunity[] = [];
    public budgetAndQuotes: SearchCRMOpportunity[] = [];
    public finalists: SearchCRMOpportunity[] = [];
    public preAwards: SearchCRMOpportunity[] = [];
    public employees: Employee[] = [];
    public budgetRevenue: number = 0;
    public finalistRevenue: number = 0;
    public preAwardRevenue: number = 0;

    public nameFilter: string = '';
    public codeFilter: string = '';
    public ownerFilter: string = '';
    public cityFilter: string = '';
    public stateFilter: string = '';
    public initiativeFilter: string = '';
    public productFilter: string = '';
    public beginActionDate: Date = new Date();
    public endActionDate: Date = new Date();
    public dateFilterChanged: boolean = false;
    public daysFilter: number = 0;
    public revenueFilter: number = 0;
    public beginCloseDate: Date = new Date();
    public endCloseDate: Date = new Date();
    public closeDateFilterChanged: boolean = false;

    public tagTypeList: SearchTagType[] = [];
    public selectedTagTypes: SearchTagType[] = [];
    public isTagListFocus: boolean = false;

    constructor(private crmService: CRMService, private employeeService: EmployeeService, private orderService: OrderService,
        public dialog: MatDialog, private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.repType = params.repType;
            this.employeeId = params.employeeId;
            this.getOpportunities();
        });

        this.getEmployees();
        //this.getSalesCycles();
        this.getTagTypeList();
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('crm user').subscribe(result => {
            this.employees = result;
        });
    }

    private getTagTypeList() {
        this.orderService.getSearchTagTypes().subscribe(result => {
            var lst: SearchTagType[] = result.resultCollection;
            //var orderTagTypes = lst.filter(t => t.recordTypeName == "QuoteOrder");
            //var loadTagTypes = lst.filter(t => t.recordTypeName == "QuoteOrderLine");
            var customerTagTypes = lst.filter(t => t.recordTypeName == "Customer");

            //orderTagTypes = orderTagTypes.sort((left, right): number => {
            //    if (left.tagTypeName < right.tagTypeName) return -1;
            //    if (left.tagTypeName > right.tagTypeName) return 1;
            //    return 0;
            //});

            //loadTagTypes = loadTagTypes.sort((left, right): number => {
            //    if (left.tagTypeName < right.tagTypeName) return -1;
            //    if (left.tagTypeName > right.tagTypeName) return 1;
            //    return 0;
            //});

            customerTagTypes = customerTagTypes.sort((left, right): number => {
                if (left.tagTypeName < right.tagTypeName) return -1;
                if (left.tagTypeName > right.tagTypeName) return 1;
                return 0;
            });

            //this.tagTypeList = [...orderTagTypes, ...loadTagTypes, ...customerTagTypes];
            this.tagTypeList = customerTagTypes;
            //console.log("ngOnInit", lst, orderTagTypes, loadTagTypes, customerTagTypes, this.tagTypeList);
        });
    }

    public toggleTagType(tagType: SearchTagType) {
        var idx: number = this.selectedTagTypes.findIndex(t => t.tagTypeID == tagType.tagTypeID);
        if (idx >= 0) {
            this.selectedTagTypes.splice(idx, 1);
        }
        else {
            this.selectedTagTypes.push(tagType);
        }
        this.filterOpportunities();
        console.log("toggleTagType", tagType, this.selectedTagTypes);
    }

    public getTagTypes(idList: string) {
        var tagTypes: SearchTagType[] = [];
        if (idList && idList != "") {
            var arr: number[] = [];
            arr = idList.replace(/, +/g, ",").split(",").map(Number);
            for (var i = 0; i < arr.length; i++) {
                var idx: number = this.tagTypeList.findIndex(t => t.tagTypeID == arr[i]);
                if (idx >= 0) {
                    tagTypes.push(this.tagTypeList[idx]);
                }
            }
        }
        return tagTypes;
    }

    public checkSelectedTagType(tagType: SearchTagType) {
        var idx: number = this.selectedTagTypes.findIndex(t => t.tagTypeID == tagType.tagTypeID);
        //console.log("checkSelectedTagType", idx);
        if (idx >= 0) {
            return "text-primary";
        }
        else {
            return "";
        }
    }

    //private getSalesCycles() {
    //    this.crmService.getSalesCycles().subscribe(result => {
    //        this.salesCycles = result.filter(s => s.endOfCycleInd == false);
    //    });
    //}

    private getOpportunities() {
        if (this.crmService.opportunities.length > 1 && !this.refreshOpps) {
            this.opportunities = this.crmService.opportunities;
            this.filterOpportunities();
        } else {
            this.crmService.getSearchCRMOpportunityByEmployeeID(this.employeeId).subscribe(result => {
                this.opportunities = result.resultCollection;
                this.filterOpportunities();
            });
        }
    }


    public filterOpportunities() {
        var today: Date = new Date();
        this.opportunities.forEach(opp => {
            if (new Date(opp.expectedCloseDate) < today) {
                opp.isPastDue = true;
            }
            else {
                opp.isPastDue = false;
            }
        });
        this.budgetAndQuotes = this.opportunities.filter(o => o.salesCycleDescription == 'Budget & Quote' &&
            (o.customerName.toLowerCase().includes(this.nameFilter.toLowerCase()) || this.nameFilter == '') &&
            (o.customerCode.toLowerCase().includes(this.codeFilter.toLowerCase()) || this.codeFilter == '') &&
            (o.ownerEmployeeName.toLowerCase().includes(this.ownerFilter.toLowerCase()) || this.ownerFilter == '') &&
            (o.cityName.toLowerCase().includes(this.cityFilter.toLowerCase()) || this.cityFilter == '') &&
            (o.stateAbbrev.toLowerCase().includes(this.stateFilter.toLowerCase()) || this.stateFilter == '') &&
            (o.initiatives.toLowerCase().includes(this.initiativeFilter.toLowerCase()) || this.initiativeFilter == '') &&
            (o.productName.toLowerCase().includes(this.productFilter.toLowerCase()) || this.productFilter == '') &&
            (o.daysInCycle >= this.daysFilter) &&
            (o.estimatedRevenue >= this.revenueFilter) &&
            ((new Date(o.maxActionDate) >= this.beginActionDate && new Date(o.maxActionDate) <= this.endActionDate) || this.dateFilterChanged == false) &&
            ((new Date(o.expectedCloseDate) >= this.beginCloseDate && new Date(o.expectedCloseDate) <= this.endCloseDate) || this.closeDateFilterChanged == false));

        this.finalists = this.opportunities.filter(o => o.salesCycleDescription == 'Finalist(50-75% win)' &&
            (o.customerName.toLowerCase().includes(this.nameFilter.toLowerCase()) || this.nameFilter == '') &&
            (o.customerCode.toLowerCase().includes(this.codeFilter.toLowerCase()) || this.codeFilter == '') &&
            (o.ownerEmployeeName.toLowerCase().includes(this.ownerFilter.toLowerCase()) || this.ownerFilter == '') &&
            (o.cityName.toLowerCase().includes(this.cityFilter.toLowerCase()) || this.cityFilter == '') &&
            (o.stateAbbrev.toLowerCase().includes(this.stateFilter.toLowerCase()) || this.stateFilter == '') &&
            (o.initiatives.toLowerCase().includes(this.initiativeFilter.toLowerCase()) || this.initiativeFilter == '') &&
            (o.productName.toLowerCase().includes(this.productFilter.toLowerCase()) || this.productFilter == '') &&
            (o.daysInCycle >= this.daysFilter) &&
            (o.estimatedRevenue >= this.revenueFilter) &&
            ((new Date(o.maxActionDate) >= this.beginActionDate && new Date(o.maxActionDate) <= this.endActionDate) || this.dateFilterChanged == false) &&
            ((new Date(o.expectedCloseDate) >= this.beginCloseDate && new Date(o.expectedCloseDate) <= this.endCloseDate) || this.closeDateFilterChanged == false));

        this.preAwards = this.opportunities.filter(o => o.salesCycleDescription == 'Pre-Award (90%)' &&
            (o.customerName.toLowerCase().includes(this.nameFilter.toLowerCase()) || this.nameFilter == '') &&
            (o.customerCode.toLowerCase().includes(this.codeFilter.toLowerCase()) || this.codeFilter == '') &&
            (o.ownerEmployeeName.toLowerCase().includes(this.ownerFilter.toLowerCase()) || this.ownerFilter == '') &&
            (o.cityName.toLowerCase().includes(this.cityFilter.toLowerCase()) || this.cityFilter == '') &&
            (o.stateAbbrev.toLowerCase().includes(this.stateFilter.toLowerCase()) || this.stateFilter == '') &&
            (o.initiatives.toLowerCase().includes(this.initiativeFilter.toLowerCase()) || this.initiativeFilter == '') &&
            (o.productName.toLowerCase().includes(this.productFilter.toLowerCase()) || this.productFilter == '') &&
            (o.daysInCycle >= this.daysFilter) &&
            (o.estimatedRevenue >= this.revenueFilter) &&
            ((new Date(o.maxActionDate) >= this.beginActionDate && new Date(o.maxActionDate) <= this.endActionDate) || this.dateFilterChanged == false) &&
            ((new Date(o.expectedCloseDate) >= this.beginCloseDate && new Date(o.expectedCloseDate) <= this.endCloseDate) || this.closeDateFilterChanged == false));

        this.filterByTagTypes();
        this.setEstimatedRevenues();
    }

    private filterByTagTypes() {
        for (var i = 0; i < this.selectedTagTypes.length; i++) {
            this.budgetAndQuotes = this.budgetAndQuotes.filter(o =>
                o.tagTypes != ""
                && (
                    o.tagTypes == this.selectedTagTypes[i].tagTypeID.toString()
                    || o.tagTypes.startsWith(this.selectedTagTypes[i].tagTypeID + ",")
                    || o.tagTypes.includes("," + this.selectedTagTypes[i].tagTypeID + ",")
                    || o.tagTypes.endsWith("," + this.selectedTagTypes[i].tagTypeID)
                )
            );
            this.finalists = this.finalists.filter(o =>
                o.tagTypes != ""
                && (
                    o.tagTypes == this.selectedTagTypes[i].tagTypeID.toString()
                    || o.tagTypes.startsWith(this.selectedTagTypes[i].tagTypeID + ",")
                    || o.tagTypes.includes("," + this.selectedTagTypes[i].tagTypeID + ",")
                    || o.tagTypes.endsWith("," + this.selectedTagTypes[i].tagTypeID)
                )
            );
            this.preAwards = this.preAwards.filter(o =>
                o.tagTypes != ""
                && (
                    o.tagTypes == this.selectedTagTypes[i].tagTypeID.toString()
                    || o.tagTypes.startsWith(this.selectedTagTypes[i].tagTypeID + ",")
                    || o.tagTypes.includes("," + this.selectedTagTypes[i].tagTypeID + ",")
                    || o.tagTypes.endsWith("," + this.selectedTagTypes[i].tagTypeID)
                )
            );
        }
        //console.log("filterByTagTypes", this.selectedTagTypes, this.quoteOrderLinesPlanned);
    }

    private setEstimatedRevenues() {
        this.budgetRevenue = 0;
        this.finalistRevenue = 0;
        this.preAwardRevenue = 0;

        this.budgetAndQuotes.forEach(opp => {
            this.budgetRevenue += opp.estimatedRevenue;
        });

        this.finalists.forEach(opp => {
            this.finalistRevenue += opp.estimatedRevenue;
        });

        this.preAwards.forEach(opp => {
            this.preAwardRevenue += opp.estimatedRevenue;
        });
    }

    public clearFilters() {
        this.nameFilter = '';
        this.codeFilter = '';
        this.ownerFilter = '';
        this.cityFilter = '';
        this.stateFilter = '';
        this.initiativeFilter = '';
        this.productFilter = '';
        this.beginActionDate = new Date();
        this.endActionDate = new Date();
        this.dateFilterChanged = false;
        this.daysFilter = 0;
        this.revenueFilter = 0;
        this.beginCloseDate = new Date();
        this.endCloseDate = new Date();
        this.closeDateFilterChanged = false;
        this.initiativesDropdown!.selectedInitiative = { title: '', description: '' } as CustomerInitiative;
        this.filterOpportunities();
    }

    public dateFilterChange(value: Date) {
        this.dateFilterChanged = true;
    }

    public closeDateFilterChange(value: Date) {
        this.closeDateFilterChanged = true;
    }

    //initiativeChanged(initiative: CustomerInitiative) {
    //    this.initiativeFilter = initiative == null ? '' : initiative.title;
    //}

    public openSalesCycleDialog(opportunitySalesCycleMapId: number) {
        this.crmService.getOpportunitySalesCylceMapById(opportunitySalesCycleMapId).subscribe(result => {
            if (result == null) return;

            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = false;
            dialogConfig.autoFocus = true;
            dialogConfig.data = {
                opportunitySalesCycleMap: result
            }

            const dialogRef = this.dialog.open(SalesCycleCheckListDialog, dialogConfig);

            dialogRef.afterClosed().subscribe(dialogResult => {
                this.refreshOpps = true;
                this.getOpportunities();
            });
        });
    }

    //editOpportunity(event, opportunitySalesCycleMapId) {
    //    event.stopPropagation();

    //    this.crmService.getOpportunitySalesCylceMapById(opportunitySalesCycleMapId).subscribe(result => {
    //        const dialogConfig = new MatDialogConfig();
    //        dialogConfig.disableClose = false;
    //        dialogConfig.autoFocus = true;
    //        dialogConfig.data = {
    //            customer: result.opportunity.customer,
    //            opportunityId: result.opportunityId,
    //            opportunitySalesCycle: result
    //        }

    //        const dialogRef = this.dialog.open(EditOpportunityDialog, dialogConfig);

    //        dialogRef.afterClosed().subscribe(dialogResult => {
    //            this.refreshOpps = true;
    //            this.getOpportunities();
    //        });
    //    });        
    //}

    public addNewOpportunity() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            customer: null,
            opportunityId: 0,
            opportunitySalesCycle: {} as OpportunitySalesCycleMap
        }

        const dialogRef = this.dialog.open(EditOpportunityDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            this.refreshOpps = true;
            this.getOpportunities();
        });
    }
}
